module.exports = __webpack_public_path__ + "media/bootstrap-icons/speedometer-d8c33d34.svg";